import { Link } from 'react-router-dom';
import { categories, getHotComics, siteInfo } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComics = getHotComics().slice(0, 3);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20Korean%20manhwa%20style%20illustration%20of%20a%20magical%20library%20filled%20with%20floating%20books%20and%20comic%20pages%2C%20warm%20golden%20and%20amber%20lighting%2C%20ethereal%20atmosphere%2C%20soft%20glowing%20particles%2C%20fantasy%20setting%2C%20rich%20warm%20colors%2C%20artistic%20composition%20with%20depth&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫网 - 免费韩漫大全"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            {siteInfo.tagline}
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 leading-relaxed max-w-xl">
            {siteInfo.description}
          </p>

          <div className="flex flex-wrap gap-3 mb-10">
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium text-sm transition-all whitespace-nowrap"
            >
              <i className="ri-book-read-line"></i>
              开始阅读
            </Link>
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white border border-white/30 px-6 py-3 rounded-lg font-medium text-sm transition-all whitespace-nowrap"
            >
              <i className="ri-fire-line"></i>
              热门推荐
            </Link>
          </div>

          <div className="flex items-center gap-6 text-white/70 text-sm">
            <div className="flex items-center gap-1.5">
              <i className="ri-book-2-line"></i>
              <span>{siteInfo.comicCount.toLocaleString()}+ 部漫画</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-user-line"></i>
              <span>{(siteInfo.dailyUsers / 10000).toFixed(0)}万+ 日活用户</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-eye-line"></i>
              <span>{(siteInfo.totalViews / 10000000).toFixed(0)}千万+ 总阅读</span>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden lg:block absolute right-8 md:right-12 bottom-8 z-10">
        <div className="flex gap-4">
          {featuredComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group relative w-28 h-40 rounded-lg overflow-hidden shadow-xl transition-transform hover:-translate-y-1"
            >
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent flex items-end p-2">
                <span className="text-white text-xs font-medium line-clamp-2">{comic.title}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}